import { createRoot } from 'react-dom/client';
import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.scss';
import './i18n';
import App from './App';
import { register as registerServiceWorker } from './pwa/serviceWorkerRegistration';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || process.env.GOOGLE_OAUTH_CLIENT_ID || '116107564760-ikigimvak8s1nla3bsegji7dvutdkuf3.apps.googleusercontent.com'}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
); 

registerServiceWorker();
